import { createMutationHook } from '~/shared/providers/api';

export const useAcceptCustomerInvitationMutation = createMutationHook(
  'crm.customerInvitationAccept',
  (params: {
    token: string;
    userData: {
      firstName: string;
      lastName: string;
      password: string;
    };
  }) => ({
    crmCustomerInvitationAccept: {
      __args: {
        input: {
          token: params.token,
          userData: params.userData,
        },
      },
      success: true,
      customerOrganizationId: true,
      customerOrganizationName: true,
      invitation: {
        id: true,
        account: {
          id: true,
          name: true,
        },
        email: true,
        invitationStatus: true,
      },
    },
  }),
);
